import React,  { useState } from "react";
import "./ExpCards.scss";

export default function(props){

  const path=`/assets/${props.name}.png`;

  return(
     <div className="ExpCards">
      <div className="cardborder">
        <div className="expertcard" id="expertcard">
        <div className="exp-photo">
         <img src={path} alt="faculty photo" className="fac-photo"/>
        </div>
        <div className="fac-description"><div className="Trainer-name">{props.fullname}</div><div className="main-description">{props.string}</div></div>
        </div>
        </div>
     </div>
  )
}
